import { LoadingButton } from '@mui/lab';
import { Grid } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
    useDeleteListDataMutation,
    useUpdateListDataMutation,
} from '../../api/apiSlice';
import FormikButton from '../../components/formik/FormikButton';
import FormikInput from '../../components/formik/FormikInput';
import FormikSelect from '../../components/formik/FormikSelect';
import Screen from '../../components/fragments/Screen';
import Form from '../../components/utilities/Form';
import { educationInputs, genderInputs, optionInputs } from '../../enums';
import errorSnackbar from '../../utils/errorSnackbar';

export default function ChildrenUpdateScreen() {
    const { id: routeId } = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const [updateChild, { isLoading }] = useUpdateListDataMutation();
    const [deleteChild, { isLoading: deleteLoading }] =
        useDeleteListDataMutation();

    const state = useSelector((st) => st);
    const { children, busy } = state.list2;

    const {
        firstName,
        surname,
        gender,
        date_of_birth,
        education,
        status: { baptised, confirmed, occupation, disability } = {},
    } = children.find(({ id }) => id == routeId) || {};

    return (
        <Screen loading={busy['children']} title="Update Child">
            <Grid item xs={12}>
                <Form
                    onSubmit={async (vals) => {
                        const { error, data } = await updateChild({
                            list: `user/children/${routeId}`,
                            body: {
                                ...vals,
                                id: routeId,
                                dob: vals.dob?.replaceAll('-', '/'),
                            },
                        });

                        errorSnackbar(error, enqueueSnackbar);

                        if (data) {
                            enqueueSnackbar('Success updating child');
                        }
                    }}
                    initialValues={{
                        firstName,
                        surname,
                        gender,
                        dob: date_of_birth,
                        education,
                        baptised: baptised,
                        confirmed: confirmed,
                        occupation,
                        disability,
                    }}
                >
                    <FormikInput
                        name="firstName"
                        label="First Name"
                        placeholder={firstName}
                    />
                    <FormikInput
                        name="surname"
                        label="Last Name"
                        placeholder={surname}
                    />
                    <FormikSelect
                        name="gender"
                        label="Gender"
                        data={genderInputs}
                    />
                    <FormikInput
                        type="date"
                        name="dob"
                        label="Date Of Birth"
                        placeholder={date_of_birth}
                    />
                    <FormikSelect
                        name="education"
                        label="Education"
                        data={educationInputs}
                    />
                    <FormikSelect
                        name="baptised"
                        label="Baptised"
                        data={optionInputs}
                    />
                    <FormikSelect
                        name="confirmed"
                        label="Confirmed"
                        data={optionInputs}
                    />
                    <FormikSelect
                        name="disability"
                        label="Disabled"
                        data={optionInputs}
                    />
                    <FormikInput
                        name="occupation"
                        label="Dream Occupation"
                        placeholder={occupation}
                    />
                    <div className="d-flex align-items-center justify-content-between">
                        <LoadingButton
                            color="secondary"
                            variant="outlined"
                            sx={{ mr: 1 }}
                            disabled={busy['children'] || isLoading}
                            loading={deleteLoading}
                            onClick={async () => {
                                const { error, data } = await deleteChild({
                                    list: `user/children/${routeId}`,
                                });

                                errorSnackbar(error, enqueueSnackbar);

                                if (data) {
                                    enqueueSnackbar('Success deleting child');
                                    navigate(-1);
                                }
                            }}
                        >
                            Delete
                        </LoadingButton>
                        <FormikButton
                            disabled={deleteLoading}
                            loading={busy['children'] || isLoading}
                            variant="contained"
                        >
                            Update Child
                        </FormikButton>
                    </div>
                </Form>
            </Grid>
        </Screen>
    );
}
